import React, {Fragment} from 'react';
import cx from 'classnames';
import { Link } from "react-router-dom";
import {connect} from 'react-redux';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import HeaderLogo from '../AppLogo';
import UserBox from './Components/UserBox';
import logo from '../../../src/assets/utils/images/brand-logo.png';
import litLogo from '../../../src/assets/utils/images/lit-logo.png';
import stbLogo from '../../../src/assets/utils/images/stb-logo.png';
import SyncFailed from './Components/SyncFailed';
import { isValidRole } from '../../utils/utils';

const WORKSPACE_LOGOS = {
    LIT: litLogo,
    STB: stbLogo,
};

class Header extends React.Component {
    render() {
        let {
            headerBackgroundColor,
            enableMobileMenuSmall,
            hideHamberger,
            workspace
            // enableHeaderShadow
        } = this.props;
        const workspaceLogo = WORKSPACE_LOGOS[workspace];
        return (
            <Fragment>
                <ReactCSSTransitionGroup
                    component="div"
                    className={cx("app-header", headerBackgroundColor,)}
                    transitionName="HeaderAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={1500}
                    transitionEnter={false}
                    transitionLeave={false}>

                   
                    
                
                    <div className={cx(
                        "app-header__content",
                        {'header-mobile-open': enableMobileMenuSmall},
                    )}>
                          {!hideHamberger && <HeaderLogo/>}
                          <div className={`logo-src ${!hideHamberger?"":"ml-4"}`}>
                          <Link to="/">
                            <img className="main-logo" src={logo} alt="Logo" />    
                            </Link>
                            </div>
                        <div className="app-header-right"> 
                            {workspaceLogo && (
                                <img
                                    className="workspace-logo"
                                    src={workspaceLogo}
                                    alt={workspace}
                                    style={{ width: 100 }}
                                />
                            )}
                            {isValidRole('MENU_ENTITLEMENT_MISMATCH') && workspace === 'STB' && <SyncFailed/>}
                            <UserBox/>
                        </div>
                    </div>
                </ReactCSSTransitionGroup>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    // enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
    closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
    headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
    workspace: state.workspaceReducer?.workspace,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);